import { render, staticRenderFns } from "./cardbasic.vue?vue&type=template&id=1a6c99f7&scoped=true&"
import script from "./cardbasic.vue?vue&type=script&lang=js&"
export * from "./cardbasic.vue?vue&type=script&lang=js&"
import style0 from "./cardbasic.vue?vue&type=style&index=0&id=1a6c99f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c99f7",
  null
  
)

export default component.exports